import React from "react"
import SectionContainer from "../components/SectionContainer"
import EducationCard from "../components/EducationCard"

import drexelPhoto from "../images/drexelphoto.jpg"

const Major = () =>
  <div>B.Sc. in Computer Science</div>

const Concentration = () => 
  <>
  <div>Concentration in</div>
  <div>Software Engineering &</div>
  <div>Artificial Intelligence</div>
  </>

const Details = () =>
  <div>2020 &bull; Cum Laude</div>

const EducationSection = () => {
  return (
    <SectionContainer header="Education">
      <EducationCard
        institute="Drexel University"
        imageURL={drexelPhoto}
        major={<Major/>}
        subsection1={<Concentration/>}
        subsection2={<Details/>}
      />
    </SectionContainer>
  )
}

export default EducationSection